import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@insight/toolkit-utils';
import { TabManager } from '../Tabs';

import {
  ProductDetailTabProtection,
  ProductDetailTabAccessories,
} from '../PDPTabs';

export const AddToCartModalTabs = ({
  accessories,
  protection,
  thirdPartyProtection,
  addToCart,
  showPrice,
}) => {
  const accessoriesTab = {
    content: (
      <ProductDetailTabAccessories
        disableNavLinks
        limit={3}
        accessories={accessories}
        addToCart={addToCart}
        showPrice={showPrice}
        categoryType={t('Accessories')}
      />
    ),
    disabled: false,
    id: 'accessories',
    name: t('Accessories'),
  };

  const protectionTab = {
    content: (
      <ProductDetailTabProtection
        disableNavLinks
        limit={3}
        protection={protection}
        thirdPartyProtection={thirdPartyProtection}
        addToCart={addToCart}
        showPrice={showPrice}
        categoryType={t('Protection plans')}
      />
    ),
    disabled: false,
    id: 'protection',
    name: t('Protection plans'),
  };

  const tabs = [
    // Conditionally add accessories and protection plans
    ...(accessories.length ? [accessoriesTab] : []),
    ...(protection.length || thirdPartyProtection.length
      ? [protectionTab]
      : []),
  ];

  return (
    <TabManager
      className="c-tab-manager"
      initialSelectedTab={tabs[0]}
      tabs={tabs}
    />
  );
};

export default AddToCartModalTabs;

AddToCartModalTabs.propTypes = {
  accessories: PropTypes.array,
  protection: PropTypes.array,
  thirdPartyProtection: PropTypes.array,
  addToCart: PropTypes.func.isRequired,
};

AddToCartModalTabs.defaultProps = {
  accessories: [],
  protection: [],
  thirdPartyProtection: [],
};
